import React, { Component, useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { userService } from '../../services/user.service'
import { validateEmail } from '../../lib/helpers/helpers'
import { Link, Navigate } from 'react-router-dom'
import guardarUsuario from '../../redux/actions/guardarUsuario'
import { Button, Col, Divider, Form, Input, Result, Row, Spin, message } from 'antd'
import { Content } from 'antd/es/layout/layout'
import Title from 'antd/es/typography/Title'
import Paragraph from 'antd/es/typography/Paragraph'
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { gradient_primary } from '../../lib/global/style'
import { cambiarPais } from '../../redux/actions/pais'
import { validarDNIBrasil } from '../../lib/helpers/data/brasil'
import { rutas } from '../../lib/routes/routes'
import { urlapi } from '../../lib/backend/data'
import AuthCode from 'react-auth-code-input'

const OlvideContrasena = (props) => {
    const [ email, setEmail ] = useState('')
    const [ password, setPassword ] = useState('')
    const [ codigo, setCodigo ] = useState('')
    const [ loading, setLoading ] = useState(false)
    const [ success, setSuccess ] = useState(false)
    const pais = useSelector(state => state.pais)
    const idioma = useSelector(state => state.idioma)
    const [messageApi, contextHolder] = message.useMessage();
    const dispatch = useDispatch()
    dispatch(guardarUsuario(false))

    const handleSubmit = (e) => {
        if(e) e.preventDefault()
        
        if (!email)     return messageApi.error("Email es requerido")
        
        if(validateEmail(email) !== true) return messageApi({
            title: "Email inválido",
            status: "error"
        })
        setLoading(true)
        return fetch(`${urlapi}/auth/forget-password`, {
            method: "POST",
            body: JSON.stringify({
                email
            }),
            headers: {
                'Content-type': "application/json"
            }
        })
        .then(res => res.json())
        .then(res => {
            if(!res){
                messageApi.error("Sin datos")
            } else if(res.message){
                messageApi.error(res.message)
            } else if(res._id){
                setSuccess(res._id)
            }
            setLoading(false)
        })
        .catch(error => {
            setLoading(false)
        })
    }

    const handleChangeEmail = (e) => {
        const { value } = e.target
        setEmail(value)
    }

    const handleChangePassword = (e) => {
        const { value } = e.target
        setPassword(value)
    }

    
    const MensajeEnviado = () => {
        
        return <div>
            <Result
                status="success"
                title="Revisa la bandeja de tu email"
                subTitle="Recibirás un mensaje de correo electrónico, haz click en el enlace para poder cambiar tu contraseña"
                extra={[
                <Button type="primary" key="console">
                    <Link to={rutas.login.slug}>Volver al inicio</Link>
                </Button>
                ]}
            />
        </div>
    }

    const formulario = () => {

        if(success) return <MensajeEnviado onChange={(val) => setCodigo(val)} />

        return <div>
            <Form onSubmit={handleSubmit} 
                className="login-form"
            >
                <Title  className='mb-2'>Olvidé mi contraseña</Title>
                <Paragraph  size='sm' mb={3}>Recibirás un código de validación para reestablecer tu contraseña</Paragraph>
                <Input mb={3} className='mb-3' type='email' placeholder='Email' prefix={<UserOutlined className="site-form-item-icon" />} onChange={handleChangeEmail} />
                <Button loading={loading} style={{ width: "100%" }} type='primary' onClick={() => handleSubmit()} >REESTABLECER CONTRASEÑA</Button>
                <Title level={5}>¿Tienes un usuario? <Link to={rutas.login.slug} style={{ fontWeight: 'bold' }}>Iniciar sesión </Link> </Title>
            </Form>
        </div>
    }
    
    return <div >
        {contextHolder}
        <Row style={{ height: "100vh" }}>
        <Col md={8} style={{ display: "flex", padding: 30, alignItems: "center" }}>
        {formulario()}
        </Col>
        <Col md={16} xs={0} style={{ background: gradient_primary, display: "flex", alignItems: "center"}}>
            <img style={{ width: "55%", margin: "0 auto"}} className='hidden-mobile' src="/images/3.png" />
        </Col>
        </Row>
    </div>
}

export default OlvideContrasena